import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0656bd6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ai-modal-content" }
const _hoisted_2 = { class: "ai-body" }
const _hoisted_3 = { class: "header-info" }
const _hoisted_4 = { class: "ai-info-text" }
const _hoisted_5 = { class: "ai-info-text-value" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-basket-shopping-plus" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-text" }, "Request", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-text lower-title" }, "Generated Text", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ai-disclaimer" }, [
  /*#__PURE__*/_createElementVNode("i", null, "Artificial Intelligence can make mistakes. Please ensure you check before you apply.")
], -1))
const _hoisted_11 = { class: "ai-footer-container" }
const _hoisted_12 = { class: "cancel-section" }
const _hoisted_13 = { class: "right-section" }
const _hoisted_14 = { class: "generate-button" }

import { computed, ref, watch, inject } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import FieldValidationFreeTextArea from "../ui/inputs/field-validation-free-text-area.vue";
import AcquaintInfoBox from "../ui/inputs/acquaint-info-box.vue";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import { FieldSize } from "@/enums/system/FieldSize";
import { TextboxValueChangeEvent } from "@/enums/ui/inputs/TextboxValueChangeEvent";
import { AIPromptsToGenerate } from "@/enums/ai/AIPromptsToGenerate";
import { useSystemConfigurationStore } from "@/stores/SystemConfigurationStore";
import { SystemConfiguration } from "acquaint-api/constants/SystemConfiguration";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import { DxButton, DxLoadIndicator } from "devextreme-vue";
import displayInfoToast from "@/alerts/infoToastAlert";
import { displayCancelConfirmationAlert } from "@/alerts/cancelConfirmationAlert";


export default /*#__PURE__*/_defineComponent({
  __name: 'ai-text-generator-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The unique identifier for the property.
   * @type {number}
   * @default 0
   */
  propertyId: {
    type: Number,
    default: 0,
  },
  /** Type of prompt to generate */
  promptToGenerate: {
    type: Number,
    default: AIPromptsToGenerate.None,
  },
  /** Id of the property room to run the AI generator for. To use this option propertyId must be passed */
  roomId: {
    type: Number,
    default: 0,
  },
  /**
   * Determines whether to display apply button.
   * @type {boolean}
   * @default false
   */
  displayApplyButton: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /** Triggered when the Apply button is clicked 
      @property response {string} AI generated text to be applied in the parent component */
  "applyAIResponse",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const apiNextClient = inject("AcquaintApiNextClient") as AcquaintApiNextClient;
const request = ref("Write text about");
const aiResponse = ref("");
const aiCredits = ref<undefined | number>();
const firstAPICallMade = ref(false);
const loading = ref(false);
const currentUserStore = useCurrentUserStore();
const currentUser = ref<CurrentUser>();

const systemConfigurationStore = useSystemConfigurationStore();

watch(
  () => showModal.value,
  async () => {
    if (!showModal.value) {
      request.value = "Write text about";
      aiResponse.value = "";
      aiCredits.value = 0;
      firstAPICallMade.value = false;
      return;
    }
    fecthAICredits();

    switch (props.promptToGenerate) {
      case AIPromptsToGenerate.PropertyDescription:
        await fetchPropertyDescriptionPrompt();
        break;
      case AIPromptsToGenerate.PropertyRoomDescription:
        await fetchRoomDescriptionPrompt();
        break;
      case AIPromptsToGenerate.PropertyRoomTemplateDescription:
        await fetchRoomTemplateDescriptionPrompt();
        break;
    }
  },
);

const fecthAICredits = async () => {
  try {
    aiCredits.value = await apiNextClient.httpGet(
      "AIResponse/GetAICreditBalance",
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    aiCredits.value = undefined;
  }
};

const fetchPropertyDescriptionPrompt = async () => {
  try {
    request.value = await apiNextClient.httpGet(
      `AIPrompt/${props.propertyId}/Property`,
    );
  } catch (err) {
    request.value = "";
    displayErrorMessage(getErrorMessage(err));
  }
};

const fetchRoomDescriptionPrompt = async () => {
  /* For new rooms, there'll be no room description. This will cause the api to return a 404 response
   * Instead, we'll get the default prompt from the system config */
  if (props.roomId === 0) {
    await getDefaultRoomPrompt();
    return;
  }

  try {
    request.value = await apiNextClient.httpGet(
      `AIPrompt/${props.propertyId}/PropertyRoom/${props.roomId}`,
    );
  } catch (err) {
    request.value = "";
    displayErrorMessage(getErrorMessage(err));
  }
};

const fetchRoomTemplateDescriptionPrompt = async () => {
  /* For new room templates, there'll be no room description. This will cause the api to return a 404 response
   * Instead, we'll get the default prompt from the system config */
  if (props.roomId === 0) {
    await getDefaultRoomPrompt();
    return;
  }

  try {
    request.value = await apiNextClient.httpGet(
      `/AIPrompt/PropertyRoomTemplate/${props.roomId}`,
    );
  } catch (err) {
    request.value = "";
    displayErrorMessage(getErrorMessage(err));
  }
};

const getDefaultRoomPrompt = async () => {
  request.value = await systemConfigurationStore.getSystemConfigurationValue(
    SystemConfiguration.AIPropertyRoomDescriptionPrompt,
  );
  request.value = request.value.replace(
    new RegExp("\\[RoomDescription\\]", "i"),
    "",
  );
};

const onAICreditsClick = async () => {
  const sitePrefix = await currentUserStore.getSitePrefix();
  const siteId = currentUser.value?.siteID ?? 0;

  const url = `https://www.acquaintcrm.co.uk/PurchaseAICredits.aspx?SitePrefix=${sitePrefix}&SiteID=${siteId}`;

  window.open(url, "_blank");
};

const fetchAIResponse = async () => {
  try {
    aiResponse.value = await apiNextClient.httpGet(
      `AIResponse?input=${request.value}`,
    );
    return true;
  } catch (err) {
    aiResponse.value = "";
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const fetchDisplayAIResponse = async () => {
  loading.value = true;

  if (await fetchAIResponse()) {
    firstAPICallMade.value = true;
    fecthAICredits();
  }

  loading.value = false;
};

watch(
  () => aiResponse.value,
  async () => {
    // Prevent blank text being written to the clipboard, as this may cause confusion with users
    if (!showModal.value || !aiResponse.value) {
      return;
    }

    try {
      await navigator.clipboard.writeText(aiResponse.value);
      displayInfoToast("Text copied to the clipboard!");
    } catch (err) {
      displayErrorMessage("Text could not be copied to clipboard");
    }
  },
);

const applyAIResponse = () => {
  emit("applyAIResponse", aiResponse.value);
  showModal.value = false;
};

const onCancelClick = async () => {
  if (props.displayApplyButton) {
    const result = await displayCancelConfirmationAlert(
      "Generated text has not been applied. Do you still want to close?",
    );
    if (!result.isConfirmed) return;
  }
  showModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showModal).value = $event)),
    title: "AI Text Generator",
    height: "600px",
    saving: loading.value
  }, {
    "non-scrollable-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createTextVNode(" Credits Remaining: "),
              _createElementVNode("span", _hoisted_5, _toDisplayString(aiCredits.value?.toString() ?? "0"), 1)
            ]),
            _createElementVNode("button", {
              class: "ai-buy-button",
              title: "Buy Credits",
              onClick: onAICreditsClick
            }, _hoisted_7)
          ]),
          _hoisted_8,
          _createVNode(FieldValidationFreeTextArea, {
            modelValue: request.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((request).value = $event)),
            height: "6rem",
            "value-change-event": _unref(TextboxValueChangeEvent).KeyUp
          }, null, 8, ["modelValue", "value-change-event"]),
          _hoisted_9,
          _createVNode(FieldValidationFreeTextArea, {
            "read-only": !firstAPICallMade.value,
            modelValue: aiResponse.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((aiResponse).value = $event)),
            height: "14rem",
            "value-change-event": _unref(TextboxValueChangeEvent).KeyUp
          }, null, 8, ["read-only", "modelValue", "value-change-event"]),
          _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(DxButton), {
              text: "Cancel",
              onClick: onCancelClick
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_unref(DxLoadIndicator), {
              visible: loading.value,
              id: "small-indicator",
              height: 20,
              width: 20
            }, null, 8, ["visible"]),
            _createVNode(_unref(DxButton), {
              visible: props.displayApplyButton,
              text: "Apply",
              onClick: applyAIResponse,
              disabled: !firstAPICallMade.value || loading.value
            }, null, 8, ["visible", "disabled"]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_unref(DxButton), {
                text: "Generate Text",
                onClick: fetchDisplayAIResponse,
                disabled: aiCredits.value == 0 || request.value == '' || loading.value,
                icon: "fa-solid fa-wand-magic-sparkles"
              }, null, 8, ["disabled"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "saving"]))
}
}

})